export const ASTREA_HOMOLOG_OVERRIDE_STORAGE_KEY = 'astreaHomologOverrideTarget'
export const ASTREA_HOMOLOG_OVERRIDE_TARGETS = ['LOCAL', 'PLAYGROUND']

export const ASTREA_PLAYGROUND_URL_STORAGE_KEY = 'astreaPlaygroundUrlOverride'
